/**
 * mc-product-page.js — Manifesto
 *
 * Interatividade leve da PDP (sections/main-product-manifesto.liquid):
 *   1. Galeria — clicar numa thumbnail troca a imagem principal.
 *   2. Total dinâmico — atualiza "Adicionar — R$X" conforme a quantidade
 *      (X = preço unitário × qty), espelhando o ProductDetailPage.tsx.
 *   3. "N unidades no carrinho" — atualiza ao mudar o carrinho (pub/sub Dawn).
 *   4. "Ver mais" da descrição (task 0026) — scroll suave até a seção
 *      #descricao (gated a prefers-reduced-motion) + foco programático.
 *      Sem JS a âncora nativa continua funcionando (salto direto).
 *
 * O add-to-cart em si é do <product-form> do Dawn (product-form.js), que abre
 * a gaveta lateral Manifesto. Este script só cuida da apresentação.
 */

(function () {
  'use strict';

  var BRL = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });

  function initGallery(root) {
    var main = root.querySelector('[data-mc-pdp-main]');
    var thumbs = root.querySelectorAll('[data-mc-pdp-thumb]');
    if (!main || !thumbs.length) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-full');
        if (full) {
          main.removeAttribute('srcset');
          main.src = full;
        }
        thumbs.forEach(function (t) {
          t.classList.toggle('is-active', t === thumb);
        });
      });
    });
  }

  function initQtyTotal(root) {
    var qtyInput = root.querySelector('[data-mc-pdp-qty]');
    var label = root.querySelector('[data-mc-pdp-add-label]');
    var priceEl = root.querySelector('[data-mc-pdp-unit-price]');
    if (!qtyInput || !label || !priceEl) return;

    var unitCents = parseInt(priceEl.getAttribute('data-mc-pdp-unit-price'), 10) || 0;
    // Só altera o label quando o produto está disponível (label = "Esgotado" some).
    if (/esgotado/i.test(label.textContent)) return;

    function render() {
      var qty = Math.max(1, parseInt(qtyInput.value, 10) || 1);
      var total = (unitCents * qty) / 100;
      label.textContent = 'Adicionar — ' + BRL.format(total);
    }

    qtyInput.addEventListener('change', render);
    qtyInput.addEventListener('input', render);
    render();
  }

  function initInCart(root) {
    var box = root.querySelector('[data-mc-pdp-in-cart]');
    if (!box) return;
    var variantId = box.getAttribute('data-variant-id');
    var countEl = box.querySelector('[data-mc-pdp-in-cart-count]');
    var suffixEl = box.querySelector('[data-mc-pdp-in-cart-suffix]');

    function apply(count) {
      if (countEl) countEl.textContent = String(count);
      if (suffixEl) suffixEl.textContent = count === 1 ? 'unidade' : 'unidades';
      box.classList.toggle('is-hidden', count <= 0);
    }

    function refresh() {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) {
          if (!cart || !cart.items) return;
          var count = 0;
          cart.items.forEach(function (it) {
            if (String(it.variant_id) === String(variantId)) count += it.quantity;
          });
          apply(count);
        })
        .catch(function () {});
    }

    if (typeof window.subscribe === 'function') {
      window.subscribe('cart-update', refresh);
    }
  }

  // Barra fixa de compra no mobile (task 0025). Só age se o markup existir
  // (settings.pdp_mobile_buybar != 'off'). O add-to-cart é do product-form.js
  // (o botão é submit externo do #mc-pdp-form) — aqui só cuidamos de: aparecer
  // ao rolar, sincronizar o stepper da barra (variante B) com a quantidade da
  // página, e o badge "N no carrinho".
  function initBuyBar(root) {
    var bar = root.querySelector('[data-mc-pdp-buybar]');
    if (!bar) return;

    var qtyInput = root.querySelector('[data-mc-pdp-qty]');

    // Aparição ao rolar: mostra a barra quando o bloco de compra sai da tela.
    var anchor = root.querySelector('[data-mc-pdp-buy-anchor]');
    if (anchor && 'IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          bar.classList.toggle('is-visible', !e.isIntersecting);
        });
      }, { rootMargin: '0px 0px -25% 0px', threshold: 0 });
      obs.observe(anchor);
    } else {
      bar.classList.add('is-visible'); // sem IntersectionObserver: sempre visível
    }

    // Variante B: o stepper da barra espelha a quantidade do form da página.
    var barQty = bar.querySelector('[data-mc-pdp-buybar-qty]');
    var minus = bar.querySelector('[data-mc-pdp-buybar-minus]');
    var plus = bar.querySelector('[data-mc-pdp-buybar-plus]');
    var barLabel = bar.querySelector('[data-mc-pdp-buybar-add-label]');
    var priceEl = root.querySelector('[data-mc-pdp-unit-price]');
    var unitCents = priceEl ? (parseInt(priceEl.getAttribute('data-mc-pdp-unit-price'), 10) || 0) : 0;
    var isStepper = bar.getAttribute('data-variant') === 'stepper';

    function getQty() { return Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1); }
    function syncBar() {
      var q = getQty();
      if (barQty) barQty.textContent = String(q);
      if (isStepper && barLabel && unitCents) {
        barLabel.textContent = 'Adicionar · ' + BRL.format((unitCents * q) / 100);
      }
    }
    function setQty(q) {
      q = Math.max(1, q);
      if (qtyInput) {
        qtyInput.value = q;
        qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      syncBar();
    }
    if (minus) minus.addEventListener('click', function () { setQty(getQty() - 1); });
    if (plus) plus.addEventListener('click', function () { setQty(getQty() + 1); });
    if (qtyInput) {
      qtyInput.addEventListener('input', syncBar);
      qtyInput.addEventListener('change', syncBar);
    }
    syncBar();

    // Badge "N no carrinho" na barra (mesmo pub/sub do bloco da página).
    var incart = bar.querySelector('[data-mc-pdp-buybar-incart]');
    if (incart) {
      var vid = incart.getAttribute('data-variant-id');
      var cnt = incart.querySelector('[data-mc-pdp-buybar-incart-count]');
      var refreshBar = function () {
        fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (cart) {
            if (!cart || !cart.items) return;
            var c = 0;
            cart.items.forEach(function (it) { if (String(it.variant_id) === String(vid)) c += it.quantity; });
            if (cnt) cnt.textContent = String(c);
            incart.classList.toggle('is-hidden', c <= 0);
          })
          .catch(function () {});
      };
      if (typeof window.subscribe === 'function') window.subscribe('cart-update', refreshBar);
    }
  }

  // "Ver mais" da descrição (task 0026). Progressive enhancement sobre a
  // âncora nativa: scroll suave (exceto reduced-motion) + foco no destino
  // (tabindex="-1" na seção) p/ leitores de tela continuarem do ponto certo.
  function initDescMore(root) {
    var link = root.querySelector('[data-mc-pdp-desc-more]');
    if (!link) return;
    var target = document.getElementById('descricao');
    if (!target) return;

    link.addEventListener('click', function (ev) {
      ev.preventDefault();
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      if (window.history && window.history.replaceState) {
        window.history.replaceState(null, '', '#descricao');
      }
      window.setTimeout(function () {
        target.focus({ preventScroll: true });
      }, reduce ? 0 : 400);
    });
  }

  function init() {
    var root = document.querySelector('[data-section-type="main-product-manifesto"]');
    if (!root) return;
    initGallery(root);
    initQtyTotal(root);
    initInCart(root);
    initBuyBar(root);
    initDescMore(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
